module.exports = __webpack_public_path__ + "img/itemico3.f0135a7a.png";